export default __webpack_public_path__ + "static/media/uniModal.a42be2ee.svg";